import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

  @Input() label = 'url';
  @Input() routerLink: string | undefined;
  @Input() href: string | undefined;
  @Input() external = false;
  @Input() disabled = false;

  @Input() icon?: string;

  externalRouterLink?: string;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (this.external && this.routerLink) {
      // Converts the route into a string that can be used with the window.open() function
      this.externalRouterLink = window.location.origin + this.router.serializeUrl(
        this.router.createUrlTree([this.routerLink])
      );
    }
  }

}
